import React, { useState } from 'react';

import { Box, Button, Stack, TextField, Typography } from '@mui/material';

import { useGenerateSuggestedSpendingGraph } from '~/hooks/apis/lere/useGenerateSuggestedSpendingGraph';
import useCurrentUser from '~/hooks/useCurrentUser';

import { LereTabComponentProps } from './types';

export default function LereSuggestedSpending({ onLereError }: LereTabComponentProps) {
  void onLereError;

  const { user } = useCurrentUser();
  const { mutate: generateSuggestedSpendingGraph, isPending } = useGenerateSuggestedSpendingGraph();
  const [adGroupBk, setAdGroupBk] = useState('');
  const [cutoffDate, setCutoffDate] = useState('');
  const [emailInput, setEmailInput] = useState<string | undefined>(undefined);
  const email = emailInput ?? user?.email ?? '';

  const handleGenerateGraph = () => {
    generateSuggestedSpendingGraph({
      email,
      adGroupBk,
      cutoffDate,
    });
  };

  return (
    <Stack spacing={4}>
      <Typography variant="h2" component="h2" gutterBottom>
        Graph Generation
      </Typography>
      <Stack spacing={2} sx={{ maxWidth: 720 }}>
        <TextField
          label="Ad Group BK"
          value={adGroupBk}
          onChange={(event) => setAdGroupBk(event.target.value)}
          required
          fullWidth
        />
        <TextField
          label="Cut Off Date"
          type="date"
          value={cutoffDate}
          onChange={(event) => setCutoffDate(event.target.value)}
          slotProps={{ inputLabel: { shrink: true } }}
          required
          fullWidth
        />
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(event) => setEmailInput(event.target.value)}
          required
          fullWidth
        />
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={handleGenerateGraph}
            disabled={!email || !adGroupBk || !cutoffDate || isPending}
          >
            {isPending ? 'Generating...' : 'Generate Graph'}
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
}
